
var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedhistoryworkflow",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_page: null,
	_history: null,
	_noMoreResults: null,
	_managee: null,
	_who_tracker: null,

	refresh: refresh,
	recalculate: recalculate,
	track: track
});

function init() {
	this._managee = null;
	this._page = 0;
	this._who_tracker = this.dispatcher.createTracker();
	this._history = [];
	this._noMoreResults = false;
	this.push({
		history: [],
		noMoreResults: false
	});
}

function triggers() {
	return {
		"load": load,
		"more": more,
		"reset": reset
	};
}

function listeners(){
	return {
		"connectivity:online": refresh,
	};
}

function load(data){
	var who = data.who;

	this._managee = who;
	this._group = data.group;
	this.track();
	this.refresh();

	this.emit("usermetrics:trigger:track", "open pathway history", {
		who,
	});
}

function uninit() {
	this._page = null;
	this._history = null;
	this._noMoreResults = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function refresh() {
	var managee = this._managee;
	var group = this._group;
	if(!managee) return;

	this._page = 0;
	this.emit("save:trigger:start");
	this.api.manage.workflow
		.history(this._page, managee, group)
		.then((results) => {
			Model.makeRecalculator("history").bind(this)(results);
			Model.makeRecalculator("noMoreResults").bind(this)(results.length < 32);
		})
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function more() {
	var managee = this._managee;
	var group = this._group;
	if (!managee) return;

	this.emit("save:trigger:start");
	this._page++;
	this.emit("usermetrics:trigger:track", "load more pathway history", {
		who: managee,
		page: this._page
	});
	return this.api.manage.workflow
		.history(this._page, managee, group)
		.then(handle_more.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function handle_more(list) {
	this._history = this._history.concat(list);
	this._noMoreResults = list.length < 32;
	this.recalculate();
}

function recalculate() {
	var history = this._history;
	var noMore = this._noMoreResults;
	this.push({history: history, noMoreResults: noMore});
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function reset() {
	this._group = null;
	this._managee = null;
	this._page = 0;
	this._history = [];
	this._noMoreResults = false;
	this.push({history: [], noMoreResults: false});
	this.emit("usermetrics:trigger:track", "close pathway history");
}

function track() {
	var who = this._managee;
	var tracker = this._who_tracker;
	var group = this._group;

	tracker.off();
	var do_refresh = refresh.bind(this);
	if(group)
		if (Array.isArray(group))
			group.forEach(g => {
				tracker.on("mqtt:managegroup/" + g + "/patient/u/" + who + "/workflow/finished", do_refresh);
			});
		else
			tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/finished", do_refresh);
	else
		tracker.on("mqtt:u/" + who + "/workflow/finished", do_refresh);
}
